// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".permissions-table {\n  width: 100%;\n}\n.permissions-table table {\n  background-color: #f8f8f8 !important;\n}\n.permissions-table tr td {\n  height: 35px !important;\n}\n.permissions-table tr td:last-child {\n  width: 50px;\n}\n.permissions-table__switch .v-input__control {\n  height: 24px;\n}\n.permissions-table__error-message {\n  margin: auto;\n}", ""]);
// Exports
module.exports = exports;
